function matchTitleHeight() {

  const titles = document.querySelectorAll(".custom-ayuvita-slider .collection-card__content h3");
  let maxHeight = 0;

  // reset height
  titles.forEach(el => {
    el.style.height = "auto";
  });

  // calculate max height
  titles.forEach(el => {
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  // apply height
  titles.forEach(el => {
    el.style.height = maxHeight + "px";
  });

}

// run on load
document.addEventListener("DOMContentLoaded", function(){
  setTimeout(matchTitleHeight, 300);
});


// debounce resize (important for F12 device change)
let resizeTimer;

window.addEventListener("resize", function(){
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function(){
    matchTitleHeight();
  }, 300);
});